module.exports = __webpack_public_path__ + "static/media/Natur_billede_app.f8f26662.jpg";